const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function initializeTokyoPlusHomeCategories() {
  const grid = document.querySelector('.catgrid-track');
  if (!grid || grid.dataset.tokyoPlusReady === 'true') return;
  grid.dataset.tokyoPlusReady = 'true';

  const style = document.createElement('style');
  style.textContent = `
    .catgrid{padding:24px 0 8px}
    .catgrid .catgrid-track{display:grid!important;grid-template-columns:repeat(8,minmax(0,1fr))!important;gap:10px!important;padding:0 24px;max-width:1200px;margin:0 auto}
    .catgrid .catgrid-tile{position:relative;aspect-ratio:1/1;border-radius:5px;overflow:hidden;display:flex;align-items:center;justify-content:center;text-decoration:none;color:inherit;transition:transform .2s,box-shadow .2s}
    .catgrid .catgrid-tile:hover{transform:translateY(-3px);box-shadow:0 10px 26px rgba(0,0,0,.09)}
    .catgrid .catgrid-img{position:absolute;inset:10px 10px 34px;display:flex;align-items:center;justify-content:center}
    .catgrid .catgrid-img img{width:var(--img-size,90%);height:var(--img-size,90%);object-fit:contain;mix-blend-mode:multiply;transition:transform .3s}
    .catgrid .catgrid-tile:hover .catgrid-img img{transform:scale(1.04)}
    .catgrid .catgrid-lbl{position:absolute;left:4px;right:4px;bottom:9px;text-align:center}
    .catgrid .catgrid-lbl-en{display:block;font-size:9.5px;line-height:1.2;letter-spacing:.09em;color:#2b2b2b;font-weight:500;text-transform:uppercase}
    @media(max-width:1100px){.catgrid .catgrid-track{grid-template-columns:repeat(4,minmax(0,1fr))!important}}
    @media(max-width:700px){.catgrid .catgrid-track{grid-template-columns:repeat(3,minmax(0,1fr))!important;padding:0 16px 12px;gap:8px}.catgrid .catgrid-lbl-en{font-size:9px;letter-spacing:.08em}}
  `;
  document.head.appendChild(style);

  const categories = [
    {
      handle: 'premium-haircare',
      label: 'HAIR CARE',
      image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/files/andhoney_melty_moist_rich_hair_oil_top_white.png?v=1784725681',
      alt: '&honey Melty Moist Rich Hair Oil',
      bg: '#f3f0ec',
      size: '78%'
    },
    {
      handle: 'k-beauty',
      label: 'K BEAUTY',
      image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/celimax_vita_a_retinal_shot_tightening_booster_gallery_01_top.png?v=1785296717',
      alt: 'K Beauty',
      bg: '#f7f3f5',
      size: '88%'
    },
    {
      handle: 'japanese-oral-care',
      label: 'ORAL CARE',
      image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/3_b14734bc-f1a4-47d9-85c5-7a690f693f18.png?v=1785296786',
      alt: 'Japanese Oral Care',
      bg: '#f3f6f6',
      size: '88%'
    },
    {
      handle: 'starbuks-japan',
      label: 'STARBUCKS JAPAN',
      image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/starbucks-sakura2026-stainless-togo-bottle-airy-blue-473ml_top_white.png?v=1785296958',
      alt: 'Starbucks Japan',
      bg: '#f2f4ef',
      size: '88%'
    }
  ];

  const existing = new Set(Array.from(grid.querySelectorAll('a[href*="/collections/"]')).map((link) => {
    const match = link.getAttribute('href').match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }));

  categories.forEach((category) => {
    if (existing.has(category.handle)) return;
    const card = document.createElement('a');
    card.className = 'catgrid-tile';
    card.href = '/collections/' + category.handle;
    card.style.background = category.bg;
    card.style.setProperty('--img-size', category.size);
    card.innerHTML = [
      '<div class="catgrid-img">',
      '<img src="' + category.image + '" alt="' + category.alt + '" loading="lazy">',
      '</div>',
      '<div class="catgrid-lbl"><span class="catgrid-lbl-en">' + category.label + '</span></div>'
    ].join('');
    grid.appendChild(card);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
  initializeTokyoPlusHomeCategories();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
    initializeTokyoPlusHomeCategories();
  });
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
